import React from "react";
import "./footer.css";
function Footer() {
  const date = new Date();
  let year = date.getFullYear();
  return (
    <>
      <footer
        className="text-center text-lg-start text-white footer_div"
       
      >
        © {year} Copyright:
        <a className="text-white" href="https://www.wishtreetech.com/">
          @ wishtree.com
        </a>
      </footer>
    </>
  );
}

export default Footer;
